(() => {
  'use strict';
  if (window.__uniDistanceReady) return;
  window.__uniDistanceReady = true;
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (instances.has(root)) return;
    const panel = root.querySelector('[data-distance-ratio]');
    if (!panel) return;
    const counters = [...panel.querySelectorAll('[data-distance-count]')];
    const controller = new AbortController();
    const on = { signal: controller.signal };
    const header = document.querySelector('.uni-header-section');
    const mobile = matchMedia('(max-width: 699px)');
    let scrollFrame = 0;
    let previousY = Math.max(0, window.scrollY);
    let travel = 0;
    const showHeader = () => header?.classList.remove('uni-reading-hidden');
    const updateHeader = () => {
      scrollFrame = 0;
      const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - innerHeight));
      const delta = y - previousY;
      previousY = y;
      if (!header || !mobile.matches || y < 120 || header.querySelector('dialog[open], [aria-expanded="true"]') || header.querySelector(':focus-visible')) {
        showHeader(); travel = 0; return;
      }
      if ((delta > 0 && travel < 0) || (delta < 0 && travel > 0)) travel = 0;
      travel += delta;
      if (travel > 24) header.classList.add('uni-reading-hidden');
      else if (travel < -10) showHeader();
    };
    const scheduleHeader = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(updateHeader); };
    header?.classList.add('uni-reading-header');
    header?.addEventListener('focusin', showHeader, on);
    window.addEventListener('scroll', scheduleHeader, { ...on, passive: true });
    mobile.addEventListener('change', () => { showHeader(); previousY = Math.max(0, window.scrollY); travel = 0; }, on);
    window.addEventListener('pageshow', showHeader, on);
    let frame = 0;
    let completed = false;
    let started = false;
    let observer;
    const allowed = () => !reduced.matches && document.body.dataset.motion !== 'none' && document.body.dataset.motionUser !== 'none' && root.dataset.motion !== 'none' && (!window.UniMotion?.allowed || window.UniMotion.allowed(root));
    const render = progress => {
      panel.style.setProperty('--ratio-progress', progress);
      panel.style.setProperty('--ratio-ink', progress > .23 ? '#fff' : '#a60814');
      counters.forEach(counter => { counter.textContent = Math.round(Number(counter.dataset.distanceCount) * progress); });
    };
    const finish = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      render(1);
      panel.dataset.animationState = 'complete';
      completed = true;
      observer?.disconnect();
    };
    const play = () => {
      if (completed || started) return;
      if (!allowed()) { finish(); return; }
      if (!panel.getClientRects().length || root.dataset.selectedModality === 'presencial') return;
      started = true;
      panel.dataset.animationState = 'running';
      render(0);
      let start;
      const tick = now => {
        if (!root.isConnected || !allowed() || root.dataset.selectedModality === 'presencial') { finish(); return; }
        if (start === undefined) start = now;
        const progress = Math.min(1, Math.max(0, (now - start - 120) / 1450));
        render(1 - Math.pow(1 - progress, 3));
        if (progress < 1) frame = requestAnimationFrame(tick);
        else finish();
      };
      frame = requestAnimationFrame(tick);
    };
    const settle = () => { if (!allowed()) finish(); };
    if (!allowed() || !('IntersectionObserver' in window)) finish();
    else {
      render(0);
      panel.dataset.animationState = 'ready';
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .45)) play();
      }, { threshold: [.45], rootMargin: '0px 0px -30px 0px' });
      observer.observe(panel);
    }
    reduced.addEventListener('change', settle, on);
    document.addEventListener('uni:motionchange', settle, on);
    const motionObserver = new MutationObserver(settle);
    motionObserver.observe(document.body, { attributes: true, attributeFilter: ['data-motion', 'data-motion-user'] });
    motionObserver.observe(root, { attributes: true, attributeFilter: ['data-motion'] });
    instances.set(root, () => { controller.abort(); observer?.disconnect(); motionObserver.disconnect(); cancelAnimationFrame(frame); cancelAnimationFrame(scrollFrame); header?.classList.remove('uni-reading-header', 'uni-reading-hidden'); });
  }
  const within = scope => {
    if (scope.matches?.('uni-program[data-distance-experience="true"]')) init(scope);
    scope.querySelectorAll?.('uni-program[data-distance-experience="true"]').forEach(init);
  };
  const cleanup = scope => {
    for (const [root, dispose] of instances) if (scope === root || scope.contains(root) || !root.isConnected) { dispose(); instances.delete(root); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => within(document), { once: true });
  else within(document);
  document.addEventListener('shopify:section:load', event => within(event.target));
  document.addEventListener('shopify:section:unload', event => cleanup(event.target));
})();
